import { jsx as n } from "react/jsx-runtime";
import '../../assets/button.css';/* empty css                    */
import { cn as s } from "../../utils.js";
const B = ({
  variant: d = "contained",
  className: i = "",
  color: t,
  href: o,
  target: N = "_self",
  children: e,
  onClick: a,
  disabled: u = !1,
  size: m = "md",
  underline: f = !0,
  type: r = "button"
}) => {
  const b = s("btn", { [`btn-${t}`]: !!t }, i), c = () => {
    switch (d) {
      case "contained":
        return /* @__PURE__ */ n(
          "button",
          {
            className: s(
              "btn-contained",
              {
                [`btn-contained--${t}`]: t
              },
              b
            ),
            disabled: u,
            type: r,
            onClick: a,
            children: e
          }
        );
      case "outlined":
        return /* @__PURE__ */ n(
          "button",
          {
            className: s(
              "btn-outlined",
              {
                [`btn-outlined--${t}`]: t
              },
              b
            ),
            disabled: u,
            type: r,
            onClick: a,
            children: e
          }
        );
      case "text":
        return /* @__PURE__ */ n(
          "button",
          {
            className: s("btn-text", b, {
              "btn-sm": m === "sm",
              "btn-md": m === "md",
              "btn-lg": m === "lg",
              "btn-underline": f
            }),
            disabled: u,
            type: r,
            onClick: a,
            children: e
          }
        );
      default:
        return /* @__PURE__ */ n(
          "button",
          {
            className: "button-contained",
            disabled: u,
            type: r,
            onClick: a,
            children: e
          }
        );
    }
  };
  return o ? /* @__PURE__ */ n("a", { href: o, target: N ?? "", children: c() }) : c();
};
export {
  B as Button
};
